import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import _ from 'underscore';
import { statusConfig } from '../config/status-config';


export const ItemComponent = (props) => {
  const { item, campaign, forwardedRef } = props;
  const renderItemContent = () => {
    if (forwardedRef) {
      return (
        <div ref={forwardedRef} className="item-content">
          <span className={classnames('statusIcon', _.result(statusConfig, item.status, 'statusEnabled_icon'))} />
          <span className={classnames('text', { disabled: item.disabled })}>
            {item.name}
          </span>
        </div>
      );
    }

    return (
      <div className="item-content">
        <span className={classnames('statusIcon', _.result(statusConfig, item.status, 'statusEnabled_icon'))} />
        <span className={classnames('text', { disabled: item.disabled })} title={item.name}>
          {item.name}
        </span>
      </div>
    );
  };

  const arrowIconClass = item.isAddedToResultList ? 'disabled' : 'enabled';

  return (
    <div className={item.isAddedToResultList ? classnames('multi-item-container added-to-result-list') : 'multi-item-container'}>
      {
        campaign ?
          <div data-id={item.Id}>
            <span className="item-content-parent-info">
              {`${campaign.Name} >`}
            </span>
            {renderItemContent()}
          </div>
          :
          renderItemContent()
      }
      {
        item.isShowAddArrow ?
          (<span className={classnames('arrow-button', 'a11y-k-listview-button', arrowIconClass, 'add-arrow-button')} />) : ''
      }
    </div>
  );
};

ItemComponent.propTypes = {
  item: PropTypes.shape({
    status: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    Id: PropTypes.number.isRequired,
    isAddedToResultList: PropTypes.bool,
    isShowAddArrow: PropTypes.bool,
  }).isRequired,
  campaign: PropTypes.objectOf(PropTypes.any),
  forwardedRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
};

ItemComponent.defaultProps = {
  campaign: null,
  forwardedRef: null,
};

